"use strict";

let map; // Holds the Google Map object
let markers = {}; // Holds marker objects
let infoWindow; // Holds the pop-up bubble
let allLocationData = {}; // Stores detailed info for locations

// Highlight a location in list and map
function highlightLocation(locationId) {
  if (!locationId || !allLocationData[locationId]) return;

  const activeItem = document.querySelector(
    `.location-item[data-location-id="${locationId}"]`
  );
  if (!activeItem) return;

  // Reset all images
  document.querySelectorAll(".location-item-image").forEach((img) => {
    img.style.display = "none";
    img.innerHTML = "";
  });

  // Get image and title
  const { image_url, title } = allLocationData[locationId];
  if (image_url) {
    const imageContainer = activeItem.querySelector(".location-item-image");
    if (imageContainer) {
      imageContainer.innerHTML = `<img src="${image_url}" alt="${title}">`;
      imageContainer.style.display = "block";
    }
  }

  // Move active item to top of list
  const listContainer = document.querySelector(".location-list-items");
  if (listContainer) {
    listContainer.insertBefore(activeItem, listContainer.firstChild);
    listContainer.scrollTo({ top: 0, behavior: "smooth" });
  }

  // Highlight active item
  document
    .querySelectorAll(".location-item")
    .forEach((item) => item.classList.remove("active"));
  activeItem.classList.add("active");

  // Focus map on marker
  const marker = markers[locationId];
  if (marker) {
    map.panTo(marker.getPosition());
    map.setZoom(15);
    infoWindow.setContent(
      `<div class="map-infowindow"><strong>${marker.getTitle()}</strong></div>`
    );
    infoWindow.open(map, marker);
  }
}

// Initialize Map with Locations
window.initMapWithLocations = function (locations = []) {
  allLocationData = Object.fromEntries(locations.map((loc) => [loc.id, loc]));

  const mapElement = document.getElementById("warehouse-map");
  if (!mapElement) return;

  // Clear old markers
  Object.values(markers).forEach((marker) => marker.setMap(null));
  markers = {};

  if (locations.length === 0) return;

  // Initialize map once
  if (!map) {
    map = new google.maps.Map(mapElement, {
      zoom: 4,
      center: {
        lat: parseFloat(locations[0].lat),
        lng: parseFloat(locations[0].lng),
      },
    });
    infoWindow = new google.maps.InfoWindow();
  }

  const bounds = new google.maps.LatLngBounds();

  // Add new markers
  locations.forEach((location) => {
    const position = {
      lat: parseFloat(location.lat),
      lng: parseFloat(location.lng),
    };
    const marker = new google.maps.Marker({
      position,
      map,
      title: location.title,
    });
    markers[location.id] = marker;

    marker.addListener("click", () => highlightLocation(location.id));
    bounds.extend(position);
  });

  if (locations.length > 1) {
    map.fitBounds(bounds);
    google.maps.event.addListenerOnce(map, "idle", () => {
      if (map.getZoom() < 18) map.setZoom(map.getZoom() + 1);
    });
  } else {
    map.setCenter(bounds.getCenter());
    map.setZoom(14);
  }
};

// --- NEW FUNCTION: Initialize Autocomplete ---
function initAutocomplete() {
  // Select the input field. The class .map-search is defined in your PHP file.
  const input = document.querySelector(".map-search");

  if (!input) return;

  const options = {
    types: ["geocode"],
    fields: ["address_components", "geometry", "icon", "name"],
    componentRestrictions: { country: "au" },
  };

  const autocomplete = new google.maps.places.Autocomplete(input, options);

  // Optional: Bias the search results to the current map view
  if (map) {
    autocomplete.bindTo("bounds", map);
  }
}

// Handle clicks on location list items
document.addEventListener("click", function (e) {
  const item = e.target.closest(".location-item");
  if (item) highlightLocation(item.getAttribute("data-location-id"));
});

// Handle location search form submit
document.addEventListener("DOMContentLoaded", () => {
  const form = document.getElementById("location-search-form");
  const loadingIndicator = document.getElementById("loading");
  const listContainer = document.querySelector(".location-list-items");

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      const input = form.querySelector("input[data-block-id]");
      const searchValue = input.value.trim();

      if (!searchValue) {
        location.reload();
        return;
      }

      // If a loading indicator exists, show it (ensure HTML has an element with id="loading")
      if (loadingIndicator) loadingIndicator.style.display = "flex";

      fetch(ajax_callback_data.ajax_url, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams({
          action: "location_search",
          nonce: ajax_callback_data.ajax_nonce,
          search: searchValue,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          if (loadingIndicator) loadingIndicator.style.display = "none";
          if (infoWindow) infoWindow.close();

          if (data.success) {
            listContainer.innerHTML = data.data.html;

            let mapElement = document.getElementById("warehouse-map");
            if (!mapElement) {
              const mapContainer = document.querySelector(
                ".location-map-column"
              );
              if (mapContainer) {
                mapContainer.innerHTML =
                  '<div id="warehouse-map" class="location-map-placeholder" aria-label="Map of locations"></div>';
              }
            }

            // Update direction links
            const originValue = encodeURIComponent(searchValue);
            document.querySelectorAll(".direction-link").forEach((link) => {
              link.href = link.href.replace(
                /origin=[^&]*/,
                `origin=${originValue}`
              );
            });

            initMapWithLocations(data.data.locations);
          } else {
            listContainer.innerHTML = `<div class="location-item"><p>${
              data.data?.message ||
              "No locations found. Please try another suburb or postcode."
            }</p></div>`;

            // Optional: Don't remove the map on error, just clear markers
            // const mapElement = document.getElementById("warehouse-map");
            // if (mapElement) mapElement.remove();
            // map = null;
            Object.values(markers).forEach((marker) => marker.setMap(null));
            markers = {};
          }
        })
        .catch(() => {
          if (loadingIndicator) loadingIndicator.style.display = "none";
          alert("An error occurred. Please try again.");
        });
    });
  }

  // Global Init Function called by Google Maps API Callback
  window.initializePage = function () {
    initMapWithLocations(
      typeof initial_locations !== "undefined" ? initial_locations : []
    );
    // We call the autocomplete init here because the Google API is definitely loaded now
    initAutocomplete();
  };
});
